import { IsArray, IsBoolean, IsInt, IsISO8601, IsNumber, IsOptional, IsString, Matches } from 'class-validator';
import { Type } from 'class-transformer';

export class UpdateRebateBodyDto {
  @IsOptional()
  @IsString()
  name?: string;

  @IsOptional()
  @IsInt()
  supplierId?: number;

  @IsOptional()
  @IsInt()
  rebateTypeId?: number;

  @IsOptional()
  @IsInt()
  settlementFrequencyId?: number;

  @IsOptional()
  @IsString()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  startDate?: string;

  @IsOptional()
  @IsString()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  endDate?: string;

  @IsOptional()
  @IsInt()
  criteriaTypeId?: number;

  @IsOptional()
  @IsNumber()
  criteriaValue?: number;

  @IsOptional()
  @IsNumber()
  monetaryFixedAmount?: number;

  @IsOptional()
  @IsNumber()
  monetaryPercentageOfSpend?: number;

  @IsOptional()
  @IsNumber()
  monetaryFixedValue?: number;

  @IsOptional()
  @IsInt()
  monetaryPaymentMethodId?: number;

  @IsOptional()
  @IsBoolean()
  @Type(() => Boolean)
  monetaryIsInvoiceRequired?: boolean;

  @IsOptional()
  @IsNumber()
  productVolume?: number;

  @IsOptional()
  @IsBoolean()
  @Type(() => Boolean)
  productIsPORequired?: boolean;

  @IsOptional()
  @IsInt()
  merchantGroupId?: number;

  @IsOptional()
  @IsArray()
  @IsNumber({}, { each: true })
  merchantIds?: number[];

  @IsOptional()
  @IsArray()
  @IsNumber({}, { each: true })
  stockCategoryIds?: number[];

  @IsOptional()
  @IsArray()
  @IsNumber({}, { each: true })
  stockIds?: number[];

}